<script setup>
import { ref, onMounted } from "vue";
import { post } from "./../mixins/http_handler";
// import { defineProps } from "vue";

const HQStudio = ref([]);
const currentYear=(new Date()).getFullYear();
HQStudio.value={
            "Name": "iLoveKickboxing - Headquarters, FL",
            "facebook_link": "ilovekickboxing",
            "instagram_link": "ilovekickboxing",
            "twitter_link": "ilovekickboxing",
            "youtube_link": "ilovekickboxingfitness",
            "tiktok_link": "@ilovekickboxing"
};
   
// const getHQStudio = () => {
//    post('/', {
//       query: `query {
//          location(id: 0) {
//             Name
//             facebook_link
//             instagram_link
//             twitter_link
//             youtube_link
//             tiktok_link
//          }
//       }`
// })
//     .then((response) => {
//       HQStudio.value = response?.data?.data?.location;
//       //console.log( HQStudio.value.facebook_link );
//     })
//     .catch((err) => {
//       console.log(err);
//     });
// };

onMounted(() => {
//  getHQStudio();
});


</script>
<template>
  <footer class="footer-wrapper" id="footer"  >
    <div class="container-fluid">
      <div
        class="row ft-log-wrap"
      >
        <div class="col-12 col-md-8 d-flex align-items-start align-items-md-center flex-column flex-md-row">
           <img
            class="img-fluid"
            src="https://res.cloudinary.com/ilovekickboxing/image/upload/f_auto,fl_lossy,q_auto:eco/v1/Brand/logo-main-white-1.png"
            style="max-height: 16px"
            alt="iLoveKickboxing Logo"
          />
          <span class="copyright_text">© 2009-{{ currentYear }} all rights reserved.</span>
        </div>
        <div class="col-12 col-md-4 socialmedia">
            <a :href="`https://www.facebook.com/` + (HQStudio?.value?.facebook_link? HQStudio?.value?.facebook_link : 'ilovekickboxing')"
               class="social-icon "  target="_blank">
                <svg width="10" height="18" viewBox="0 0 10 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.34473 10.1247L9.86346 6.86724H6.62096V4.75337C6.62096 3.86237 7.07375 2.99331 8.52608 2.99331H10V0.220182C10 0.220182 8.66262 0.000244141 7.38359 0.000244141C4.7135 0.000244141 2.96826 1.56062 2.96826 4.38493V6.86781H0V10.1252H2.96826V18.0002H6.62096V10.1252L9.34473 10.1247Z" />
              </svg>
            </a>
            <a :href="`//www.instagram.com/` + (HQStudio?.value?.instagram_link? HQStudio?.value?.instagram_link : 'ilovekickboxing')"
            class="social-icon "   target="_blank">
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.49745 5.99897C7.75305 5.99897 6.32949 7.34763 6.32949 9.00024C6.32949 10.6529 7.75305 12.0015 9.49745 12.0015C11.2418 12.0015 12.6654 10.6529 12.6654 9.00024C12.6654 7.34763 11.2418 5.99897 9.49745 5.99897ZM18.9989 9.00024C18.9989 7.7574 19.0108 6.52582 18.9371 5.28523C18.8635 3.84426 18.5165 2.5654 17.4043 1.51168C16.2897 0.455721 14.9421 0.129251 13.4211 0.0594534C12.1093 -0.0103438 10.8093 0.000913842 9.49982 0.000913842C8.18796 0.000913842 6.88798 -0.0103438 5.5785 0.0594534C4.0575 0.129251 2.70761 0.457973 1.59538 1.51168C0.480772 2.56765 0.136171 3.84426 0.0624975 5.28523C-0.0111759 6.52807 0.000706894 7.75966 0.000706894 9.00024C0.000706894 10.2408 -0.0111759 11.4747 0.0624975 12.7153C0.136171 14.1562 0.483149 15.4351 1.59538 16.4888C2.70999 17.5448 4.0575 17.8712 5.5785 17.941C6.89036 18.0108 8.19034 17.9996 9.49982 17.9996C10.8117 17.9996 12.1117 18.0108 13.4211 17.941C14.9421 17.8712 16.292 17.5425 17.4043 16.4888C18.5189 15.4328 18.8635 14.1562 18.9371 12.7153C19.0132 11.4747 18.9989 10.2431 18.9989 9.00024ZM9.49745 13.6181C6.80005 13.6181 4.62312 11.5557 4.62312 9.00024C4.62312 6.44477 6.80005 4.38237 9.49745 4.38237C12.1948 4.38237 14.3718 6.44477 14.3718 9.00024C14.3718 11.5557 12.1948 13.6181 9.49745 13.6181ZM14.5714 5.27172C13.9416 5.27172 13.433 4.7899 13.433 4.19325C13.433 3.59659 13.9416 3.11477 14.5714 3.11477C15.2012 3.11477 15.7098 3.59659 15.7098 4.19325C15.71 4.33492 15.6806 4.47524 15.6235 4.60617C15.5664 4.7371 15.4825 4.85606 15.3768 4.95624C15.271 5.05642 15.1455 5.13586 15.0073 5.18999C14.8691 5.24413 14.721 5.2719 14.5714 5.27172Z" />
              </svg>
            </a>
            <a :href="`//www.twitter.com/` + (HQStudio?.value?.twitter_link? HQStudio?.value?.twitter_link : 'ilovekickboxing')"
            class="social-icon "  target="_blank">
                 <svg width="19" height="16" viewBox="0 0 19 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.4263 2.28733C17.7487 2.58759 17.0207 2.79047 16.2555 2.88217C17.0451 2.4097 17.6358 1.66608 17.9175 0.79008C17.1756 1.23072 16.3637 1.54089 15.517 1.70709C14.9476 1.09916 14.1935 0.696209 13.3716 0.560806C12.5498 0.425403 11.7062 0.565121 10.9719 0.958269C10.2376 1.35142 9.65361 1.976 9.31065 2.73504C8.96768 3.49409 8.88491 4.34513 9.07518 5.15604C7.572 5.08056 6.10149 4.68986 4.75907 4.00929C3.41666 3.32871 2.23235 2.37348 1.28301 1.20558C0.9584 1.76552 0.771752 2.41474 0.771752 3.10615C0.77139 3.72858 0.924668 4.34147 1.21799 4.89045C1.51131 5.43944 1.9356 5.90753 2.45321 6.25321C1.85292 6.23411 1.26586 6.0719 0.740914 5.78009V5.82878C0.740854 6.70176 1.04282 7.54788 1.59559 8.22356C2.14835 8.89925 2.91786 9.36288 3.77355 9.53579C3.21667 9.6865 2.63283 9.7087 2.06612 9.60071C2.30754 10.3519 2.77782 11.0087 3.4111 11.4793C4.04438 11.9499 4.80898 12.2107 5.59784 12.2252C4.2587 13.2764 2.60487 13.8466 0.902406 13.8441C0.600831 13.8442 0.299511 13.8266 0 13.7914C1.7281 14.9025 3.73974 15.4922 5.79422 15.4899C12.7489 15.4899 16.5509 9.72974 16.5509 4.73405C16.5509 4.57174 16.5468 4.40782 16.5395 4.24552C17.279 3.71071 17.9174 3.04844 18.4247 2.28976L18.4263 2.28733Z" />
              </svg>
            </a>
            <a :href="`//www.youtube.com/` + (HQStudio?.value?.youtube_link? HQStudio?.value?.youtube_link : 'ilovekickboxing')"
            class="social-icon " target="_blank">
                <svg width="22" height="16" viewBox="0 0 22 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.4783 3.07957C21.3565 2.64531 21.1194 2.25216 20.7921 1.9419C20.4555 1.6221 20.043 1.39334 19.5935 1.27721C17.9112 0.833788 11.1711 0.833788 11.1711 0.833788C8.36127 0.801819 5.55211 0.942426 2.7595 1.25482C2.30998 1.37952 1.89824 1.6134 1.56091 1.93563C1.22946 2.25454 0.989389 2.64779 0.863976 3.07868C0.56271 4.70165 0.416334 6.34957 0.426822 8.00024C0.416073 9.64941 0.562089 11.2968 0.863976 12.9218C0.986701 13.3509 1.22588 13.7424 1.55823 14.0586C1.89057 14.3748 2.30443 14.6032 2.7595 14.7242C4.46422 15.1667 11.1711 15.1667 11.1711 15.1667C13.9845 15.1987 16.7973 15.0581 19.5935 14.7457C20.043 14.6295 20.4555 14.4008 20.7921 14.081C21.1235 13.7647 21.3591 13.3715 21.4774 12.9433C21.7865 11.3209 21.9368 9.67234 21.9262 8.02084C21.9494 6.36235 21.7993 4.70597 21.4783 3.07868V3.07957ZM9.02835 11.0675V4.93389L14.6361 8.00113L9.02835 11.0675Z" />
              </svg>
            </a>
            <a :href="`//www.tiktok.com/` + (HQStudio?.value?.tiktok_link? HQStudio?.value?.tiktok_link : '@ilovekickboxing')"
            class="social-icon "   target="_blank">
                <svg width="14" height="18" viewBox="0 0 448 512" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                <path
                  d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z" />
              </svg>
            </a>
        </div>
      </div>
    </div>
  </footer>
</template>
